/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InternalTemplateTypeDTO } from '../models/InternalTemplateTypeDTO';
import type { InternalTemplateTypeDTOODataListResponse } from '../models/InternalTemplateTypeDTOODataListResponse';
import type { TemplateType } from '../models/TemplateType';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InternalTemplateTypeService {

    /**
     * @param top The max number of records.
     * @param skip The number of records to skip.
     * @param filter A function that must evaluate to true for a record to be returned.
     * @param select Specifies a subset of properties to return. Use a comma separated list.
     * @param orderby Determines what values are used to order a collection of records.
     * @param expand Use to add related query data.
     * @param count Include the overall count
     * @returns InternalTemplateTypeDTOODataListResponse Success
     * @throws ApiError
     */
    public static getInternalTemplateType(
top?: string,
skip?: string,
filter?: string,
select?: string,
orderby?: string,
expand?: string,
count?: string,
): CancelablePromise<InternalTemplateTypeDTOODataListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/TemplateType',
            query: {
                '$top': top,
                '$skip': skip,
                '$filter': filter,
                '$select': select,
                '$orderby': orderby,
                '$expand': expand,
                '$count': count,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns InternalTemplateTypeDTO Success
     * @throws ApiError
     */
    public static postInternalTemplateType(
requestBody?: InternalTemplateTypeDTO,
): CancelablePromise<InternalTemplateTypeDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal/TemplateType',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns InternalTemplateTypeDTO Success
     * @throws ApiError
     */
    public static getInternalTemplateType1(
key: number,
): CancelablePromise<InternalTemplateTypeDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/TemplateType/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @param requestBody 
     * @returns InternalTemplateTypeDTO Success
     * @throws ApiError
     */
    public static putInternalTemplateType(
key: number,
requestBody?: InternalTemplateTypeDTO,
): CancelablePromise<InternalTemplateTypeDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/internal/TemplateType/{key}',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns any Success
     * @throws ApiError
     */
    public static deleteInternalTemplateType(
key: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/internal/TemplateType/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param clientId 
     * @param query 
     * @returns TemplateType Success
     * @throws ApiError
     */
    public static getInternalTemplateTypeQuery(
clientId?: number,
query?: string,
): CancelablePromise<Array<TemplateType>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/TemplateType/query',
            query: {
                'clientId': clientId,
                'query': query,
            },
        });
    }

}
